import React, { useState, useContext } from "react";

import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

/* local components */
import Graphs from "../Graphs/Graphs";

/* context for hooks */
import { UIContext } from "../../context/UIContext";

import "./GraphPane.scss";

const useStyles = makeStyles({
  root: {
    background: "#1A2643",
    borderTop: "none",
    position: "fixed"
  },
  drawerButton: {
    backgroundColor: "#1A2643",
    borderRadius: "2px",
    border: "none",
    bottom: "0",
    height: "30px",
    left: "50%",
    position: "absolute",
    zIndex: "1000",
    "&:hover": {
      backgroundColor: "#1A2643"
    },
    "@media only screen and (max-width: 500px)": {
      left: "48.5%"
    },
    "@media only screen and (max-width: 750px)": {
      left: "47.5%"
    }
  },
  drawerButtonToggled: {
    bottom: "27vh",
    "@media only screen and (max-height: 850px)": {
      bottom: "31vh"
    },
    "@media only screen and (max-height: 1000px)": {
      bottom: "29vh"
    }
  },
  fullList: {
    height: "27vh",
    width: "99%",
    zIndex: "1000",
    "@media only screen and (max-height: 850px)": {
      height: "31vh"
    },
    "@media only screen and (max-height: 1000px)": {
      height: "29vh"
    }
  },
  paper: {
    background: "transparent",
    boxShadow: "none",
    paddingLeft: "2vw",
    width: "96vw"
  }
});

const GraphPane = ({ deck, selectedSpotter, sizeScale, pointData }) => {
  // isToggled, selectedSpotter, sizeScale }) => {
  const classes = useStyles();

  const { isDrawerOpen, setIsDrawerOpen } = useContext(UIContext);
  const [drawerState, setDrawerState] = useState({
    bottom: isDrawerOpen
  });

  const toggleDrawer = (side, open) => event => {
    toggleButtonClass();

    // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    //     return;
    // }

    setDrawerState({ ...drawerState, [side]: open });
  };

  const toggleButtonClass = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div>
      <Button
        className={
          isDrawerOpen
            ? `${classes.drawerButton} ${classes.drawerButtonToggled}`
            : `${classes.drawerButton}`
        }
        onClick={toggleDrawer("bottom", !drawerState.bottom)}
      >
        {isDrawerOpen ? (
          <ArrowDropDownIcon style={{ color: "#C4C4C4" }} />
        ) : (
          <ArrowDropUpIcon style={{ color: "#C4C4C4" }} />
        )}
      </Button>
      <Drawer
        BackdropProps={{ invisible: true }}
        anchor="bottom"
        classes={{ paper: classes.root }}
        open={isDrawerOpen}
        onClose={toggleDrawer("bottom", false)}
        variant="persistent"
      >
        <div
          className={classes.fullList}
          role="presentation"
          // onClick={toggleDrawer('bottom', false)}
          onKeyDown={toggleDrawer("bottom", false)}
        >
          <Grid container>
            <Grid item lg={11} md={10} xs={10}>
              <Paper className={classes.paper}>
                {selectedSpotter ? (
                  <Graphs
                    deck={deck}
                    // isToggled={isToggled}
                    sizeScale={sizeScale}
                    spotterId={selectedSpotter.spotterId}
                  />
                ) : (
                  <Graphs
                    deck={deck}
                    // isToggled={isToggled}
                    pointData={pointData}
                    sizeScale={sizeScale}
                    // spotterId={selectedSpotter.spotterId}
                  />
                )}
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </div>
  );
};

export default GraphPane;
